import React, { useRef } from 'react'
import buttonBgInactive from '@assets/menu/background-autoplay-option-button-inactive.svg'
import buttonBg from '@assets/menu/background-autoplay-option-button.svg'
import { useConfigurationStore, useBetSliderStore } from '@stores'
import useGetBetAmount from '@hooks/useGetBetAmount'
import { formatMoney } from '@utils/money'
import { useShrinkTextToFit } from '@amusnet/react-ui'

interface AutoplaySettingsOptionButtonProps {
    spins: string
    label: string
    isActive: boolean
    onClick: () => void
    id?: string
}

const AutoplaySettingsOptionButton: React.FC<AutoplaySettingsOptionButtonProps> = ({
    spins,
    label,
    isActive,
    onClick,
    id,
}) => {
    const currencyHideCents = useConfigurationStore((state) => state.currencyHideCents)
    const centsVisibilityMoneyLimit = useConfigurationStore((s) => s.centsVisibilityMoneyLimit)
    const shouldShowCentsOnMoneyLimit = useConfigurationStore((s) => s.shouldShowCentsOnMoneyLimit)
    const currency = useConfigurationStore((state) => state.currency)
    const hideCentsWhenMultipleOf = useBetSliderStore((state) => state.hideCentsWhenMultipleOf)
    const betAmount = useGetBetAmount()
    const spinsCostRef = useRef<HTMLSpanElement>(null)
    const shouldHideCents =
        currencyHideCents ||
        (Number(spins) * betAmount > centsVisibilityMoneyLimit &&
            !shouldShowCentsOnMoneyLimit &&
            Boolean(hideCentsWhenMultipleOf && (Number(spins) * betAmount) % hideCentsWhenMultipleOf === 0))
    const spinsCost = isNaN(Number(spins)) ? undefined : formatMoney(Number(spins) * betAmount, shouldHideCents)

    useShrinkTextToFit({
        refresh: [spinsCost],
        designFontSize: 18,
        bounds: { width: 120 },
        textRef: spinsCostRef,
    })

    return (
        <button
            id={id}
            onClick={onClick}
            className=" relative w-[136px] h-[120px] flex flex-col gap-1 p-2 rounded-lg overflow-hidden items-center"
        >
            <img
                src={isActive ? buttonBg : buttonBgInactive}
                alt="Autoplay Button Background"
                className="absolute inset-0 w-full h-full object-cover"
                draggable="false"
            />
            <span className="font-black text-[46px] leading-[44px] z-10 whitespace-nowrap text-white">{spins}</span>
            <span className="text-yellow-label font-bold text-[20px] leading-[24px] z-10">{label}</span>

            {spinsCost && (
                <>
                    <div className="min-h-[2px] w-full bg-gradient-to-r from-transparent via-[#888888] to-transparent mx-auto z-10 my-[2px]"></div>
                    <span
                        ref={spinsCostRef}
                        className="text-white font-bold text-[18px] leading-[16px] z-10 whitespace-nowrap"
                    >
                        {spinsCost} {currency}
                    </span>
                </>
            )}
        </button>
    )
}

export default AutoplaySettingsOptionButton
